const numberWithThousandSeparator = (val) => Math.floor(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export default (val) => (`$${numberWithThousandSeparator(val)}`);
